import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Typography } from '@mui/material';

import './OnboardBiometricLogin.css';

export function OnboardBiometricLogin({ closePopup }: { closePopup: () => Promise<void> }) {
  const { t } = useTranslation();

  const switchBiometric = useCallback(
    (v: string) => {
      localStorage.setItem('biometriclogin', v);
      closePopup();
    },
    [closePopup]
  );

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined = setTimeout(() => {
      switchBiometric('off');
      timer = undefined;
    }, 8000);

    return () => timer && clearTimeout(timer);
  }, [switchBiometric]);

  return (
    <div className="biometric-page">
      <Typography variant="h4" pt={'10%'}>
        {t('onboarding.biometric.title')}
      </Typography>
      <Typography sx={{ p: 6 }}>{t('onboarding.biometric.subtitle')}</Typography>

      <Typography sx={{ p: 6 }}>{t('onboarding.biometric.subtitle2')}</Typography>

      <Button
        onClick={() => switchBiometric('true')}
        variant="contained"
        color="secondary"
        type="submit"
        sx={{ borderRadius: 28 }}
      >
        {t('onboarding.biometric.ok')}
      </Button>

      <div className="biometric-page-smalltext">
        <a onClick={() => switchBiometric('off')}>
          <Typography variant="helperText">{t('onboarding.biometric.notok')}</Typography>
        </a>
      </div>
    </div>
  );
}
